import { render, staticRenderFns } from "./InspectionStats.vue?vue&type=template&id=4d84caca&"
import script from "./InspectionStats.vue?vue&type=script&lang=js&"
export * from "./InspectionStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports